<template>
    <div class="container remove-padding-margin">
        <div class="alert" role="alert" id="alert" v-on:click="closeAlert">
            <i class="fa fa-times" aria-hidden="true" id="close" style="float: right"></i>
            <p class="remove-margin" id="contentAlert"></p>
        </div>
        <div id="loadingPage" class="overlayLoading">
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            <p class="text-center tunggu">
                Tunggu Sebentar
            </p>
            <p class="text-center data">
                Data anda masih diproses...
            </p>
        </div>
        <main class="add-padding-default w-limit">
            <div class="contain flex-100">
                <div class="row justify-content-center align-items-center remove-padding-margin">
                    <div class="col-md-12 remove-padding-margin">
                        <div class="skip">
                            <a data-toggle="modal" data-target="#modalOut" style="color: #206CFF">Lewati</a>
                        </div>
                    </div>
                </div>

                <div class="row justify-content-center align-items-center remove-padding-margin">
                    <div class="col-md-12 remove-padding-margin d-flex justify-content-center">
                        <div class="logo">
                            <img src="../../assets/img/illustrator_Success.svg" alt="">
                        </div>
                    </div>
                </div>

                <div class="conten-2 flex-1">
                    <div class="text-sukses remove-padding-margin">
                        <h3 class="remove-margin">Berhasil Terdaftar!</h3>
                        <p class="remove-margin">Selamat akun anda berhasil dibuat.
                            Silahkan ikuti panduan untuk mempelajari sistem Smartlink</p>
                    </div>
                </div>

                <div class="button-lanjut">
                    <button class="btn btn-login btn-long remove-margin" @click="godashboard">Ikuti Panduan</button>
                </div>
            </div>

        </main>
        <div class="modal fade" id="modalOut" role="dialog">
            <div class="modal-dialog modal-lg  bani-modal">
                <div class="modal-content w-limit">
                    <div class="modal-header">
                        <div class="nav-btn kiri"></div>
                        <h5 class="navbar-title text-center">Lewati Panduan?</h5>
                        <div class="nav-btn kanan tutup">
                            <img src="../../assets/img/x2.svg" data-dismiss="modal" alt="">
                        </div>
                    </div>
                    <div class="modal-body">
                        <p>Tenang saja, anda selalu bisa mengulang panduan dari menu "bantuan". Apakah Anda yakin
                            ingin melewatkan panduan? </p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-outline-primary btn-long" data-dismiss="modal"
                                @click="updateStepWalkthroughFinsih">Ya, lewati saja
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "SuccessRegis",
        mounted() {
            this.generatedData();
            $('#alert').hide()
        },
        data() {
            return {
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                }
            }
        },
        methods: {
            next() {
                this.$router.push('/dashboard')
            },
            godashboard() {
                this.$router.push('/dashboard')
            },
            async updateStepWalkthroughFinsih() {
                var walkthrough = 3
                try {
                    const datawalkthrough = new FormData
                    datawalkthrough.append('walkthrough', walkthrough)
                    const response = await this.$axios.post(this.$baseurl + '/masterData/owner/update_status_walkthrough', datawalkthrough, this.requestHeaders);
                    if (response.data.code === 200) {
                        if (response.data.status === true) {
                            localStorage.setItem("step_walkthrough", walkthrough)
                            this.godashboard()
                        }
                    } else {
                        this.popupType = "error";
                        this.popupMessage = response.data.msg;
                    }
                } catch (e) {
                    if (!e.code) {
                        this.popupType = "error";
                        this.popupErrorException = e;
                    }
                }
            },
            closeAlert() {
                $('#alert').removeClass("alert-danger animated fadeInDown");
                $('#alert').addClass("alert-danger animated fadeOutUp");
            },
            async getdetailowner() {
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/data_detail_owner', this.requestHeaders);
                    if (response.data.status === true) {
                        if (response.data.data.walkthrough >= 3){
                            this.$router.push('/dashboard')
                        }else{
                            $('#loadingPage').fadeOut();
                        }
                    }
                } catch (e) {
                    if (!e.code) {
                        this.popupType = "error";
                        this.popupErrorException = e;
                    }
                }
            },
            async generatedData() {
                var idowner = localStorage.getItem("idowner");
                if (idowner === null) {
                    this.$router.push('/login')
                } else {
                    try {
                        const dataForm = new FormData;
                        dataForm.append('idowner', idowner);
                        const res = await this.$axios.post(this.$baseurl + '/auth/generate_data_akun', dataForm);
                        if (res.status === 200) {
                            this.getdetailowner()
                        }
                    } catch (e) {
                        if (!e.code) {
                            $('#alert').show()
                            $('#contentAlert').text("Terjadi kesalahan mohon periksa koneksi internet Anda atau coba lagi nanti");
                            $('#alert').removeClass("alert alert-danger animated fadeOutUp");
                            $('#alert').addClass("alert alert-danger animated fadeInDown");
                            $('#close').show()
                            setTimeout(() => {
                                $('#alert').removeClass("alert alert-danger animated fadeInDown");
                                $('#alert').addClass("alert alert-danger animated fadeOutUp");
                            }, 30000)
                            this.isClicked = false
                            $('#textbtn').show();
                            $('#nextbutton').prop('disabled', false);
                        }
                        else if (e.response.status === 500) {
                            $('#alert').show()
                            $('#contentAlert').text(e.response.data.msg);
                            $('#alert').removeClass("alert alert-danger animated fadeOutUp");
                            $('#alert').addClass("alert alert-danger animated fadeInDown");
                            $('#close').show()
                            this.isClicked = false
                            $('#textbtn').show();
                            $('#nextbutton').prop('disabled', false);
                        }else {
                            $('#contentAlert').text(e.response.data.msg);
                            $('#alert').removeClass("alert alert-danger animated fadeOutUp");
                            $('#alert').addClass("alert alert-danger animated fadeInDown");
                            $('#close').show()
                            this.isClicked = false
                            $('#textbtn').show();
                            $('#nextbutton').prop('disabled', false);
                        }
                        this.$router.push('/login')
                    }
                }
            },
        }
    }

</script>

<style scoped>
    .skip {
        text-align: right;
        padding-top: 20px;
        padding-bottom: 54px;
    }

    .logo img {
        margin-bottom: 28px;
    }

    .text-sukses.remove-padding-margin p {
        text-align: center;
        font-size: 16px;
        line-height: 140%;
        color: #808080;
    }

    .skip {
        text-align: right;
        padding-top: 20px;
        padding-bottom: 54px;
    }

    .logo img {
        margin-bottom: 28px;
    }

    .text-sukses.remove-padding-margin h3 {
        text-align: center;
        font-size: 18px;
        line-height: 25px;
    }

    .text-sukses.remove-padding-margin p {
        text-align: center;
        font-size: 16px;
        line-height: 140%;
        color: #808080;
    }

    .overlayLoading {
        position: fixed;
        display: inline;
        width: 100%;
        height: 100%;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        background-color: white;
        z-index: 9999;
    }

    .spinner-border-sm {
        width: 3rem;
        height: 3rem;
        border-width: .3em;
        top: 40% !important;
        text-align: center;
        margin-top: 70%;
        margin-left: 45%;
        color: grey;
    }

    .tunggu {
        margin-top: 15px;
        margin-bottom: 0px;
        font-style: normal;
        font-weight: bold;
        font-size: 16px;
        line-height: 25px;
        text-align: center;
        letter-spacing: -0.02em;
        color: #333333;
    }

    .data {
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 140%;
        text-align: center;
        letter-spacing: -0.02em;
    }
</style>